import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import { showLoading, hideLoading } from '../../redux/slices/loadingSlice';
import { store } from '../../redux/store'
import { useNavigate } from "react-router";
import { showToast } from "../../redux/slices/toastSlice";
import { setNetwrokTrue } from "../../redux/slices/netWorkErr";





const BASE_URL = "https://barsaraa.maksiran.ir/api";
const TIMEOUT = 600000;

axios.defaults.baseURL = BASE_URL;
axios.defaults.timeout = TIMEOUT;

// let expiration = moment(JSON.parse(localStorage.getItem("sayahUser"))?.expiration);
// let current = moment();

// if (expiration <= current) {
//   await store.dispatch(setLogoutAction());
// }




axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token_barsara') || null}`;

const requestOnFullFilled = (config) => {

  if (config.method && config.method.toLowerCase() === "get") {
    // store.dispatch(showLoading());
  }
  return config;
};

const requestOnRejected = (error) => {
  if (
    error.config &&
    error.config.method &&
    error.config.method.toLowerCase() === "get"
  ) {
    // store.dispatch(showLoading());
  }
  return Promise.reject(error);
};

const responseOnRejected = async (error) => {
  store.dispatch(hideLoading());


  if (error) {
    // return error.response;
    const { status } = error;
    if (status) {
      if (status === 401 || status == 403) {
        store.dispatch(showToast({ message: "نشست کاری شما به پایان رسیده است", type: "error" }))

        setTimeout(() => {
          window.location.href = "/login"
        }, 1100);

      }
    }
  
    if ([500, 502, 503, 504].includes(status)) {
        store.dispatch(setNetwrokTrue())
      } 

  }
  

  throw error;
};

axios.interceptors.request.use(requestOnFullFilled, requestOnRejected);

axios.interceptors.response.use(undefined, responseOnRejected);

const responseBody = (response) => {
  store.dispatch(hideLoading());
  return response;
};

const errorBody = (error) => {
  store.dispatch(hideLoading());
  throw error?.response;
};

const requests = {


  get: (url, params) => axios.get(url, { params }).then(responseBody).catch(errorBody),

  getByParams: (url, params) =>
    axios.get(url, { params }).then(responseBody).catch(errorBody),
  post: (url, body) =>
    axios.post(url, body).then(responseBody).catch(errorBody),
  put: (url, body) => axios.put(url, body).then(responseBody).catch(errorBody),
  patch: (url, body) =>
    axios.patch(url, body).then(responseBody).catch(errorBody),
  delete: (url, body) => axios.delete(url, { data: body }).then(responseBody),

  postFormData: (url, formData) => {
    return axios
      .post(url, formData, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody);
  },
  putMedia: (url, body) => {
    return axios
      .put(url, body, {
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
        },
      })
      .then(responseBody)
      .catch(errorBody);
  },
};

export default requests;
